import { Typography } from "@mui/material";
import { TypographyProps } from "../types/prop-types";

const Subtitle = ({ sx, center, children, color = "", textAlign = "unset" }: TypographyProps) => (
  <Typography variant="body1" sx={{ ...sx, textAlign: center ? "center" : textAlign }} color={color}>
    {children}
  </Typography>
);

export default Subtitle;
